export default "__VITE_ASSET__4529732c__"